module.exports = __webpack_public_path__ + "static/media/dai-logo.9c67d5fdfe953c8a6756f287a874c934.svg";